export const linkInTextRegex =
  /\[([^\[\]]+)\]\((((https?:\/\/)|mailto:|tel:)[\w\d./?=#&@%\+\-\s]+)\)/g;
export const linkRegex =
  /^\[([^\[\]]+)\]\((((https?:\/\/)|mailto:|tel:)[\w\d./?=#&@%\+\-\s]+)\)/;

export function encodeQueryParams(url) {
  const [baseUrl, queryParams] = url.split('?');
  if (!queryParams) return baseUrl;
  const encodedParams = queryParams
    .split('&')
    .map(param => param.split('=').map(encodeURIComponent).join('='))
    .join('&');
  return `${baseUrl}?${encodedParams}`;
}
